import PartsFormV3 from './PartsFormV3';
import PartsFormV3Modal from './Modal';
import PartsProviderInputs from './PartsProviderInputs';

export default PartsFormV3;
export { PartsFormV3Modal, PartsProviderInputs };
